import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import DisciplinaTable from './DisciplinaTable';
import DisciplinaForm from './DisciplinaForm';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    }
});

export default function PlanejamentoContainer() {
    const classes = useStyles();
    const disciplinaRedux = useSelector(state => state.disciplina);
    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Typography className={classes.title} variant="h6">
                    Disciplinas
                </Typography>
                {disciplinaRedux ?
                    <DisciplinaForm /> :
                    <DisciplinaTable />
                }




            </Container>

        </div>
    );
}